/* eslint-disable no-undef */

import { render } from 'react-dom';
import React from 'react';
import App from './app/App';

export default function mountShuttersModal(mountSiteId) {
  const mountSite = document.getElementById(mountSiteId);
  if (mountSite) {
    render(<App
      ref={(SFIDialog) => { window.SFIDialog = SFIDialog; }}
      sfiPhoneNumber={window.pageContextJavascript.SFIPhoneNumber}
    />, mountSite);
  } else {
    // eslint-disable-next-line no-console
    console.log(`${mountSiteId} not found......`);
  }
}

export function openDialog() {
  $.colorbox({
    inline: true,
    href: '#shutters-div',
    transition: 'none',
    width: '95%',
    height: '80%',
    maxWidth: '960px',
    maxHeight: '860px',
    onCleanup() {
      window.SFIDialog.hide();
      $('html').css({ overflow: '' });
    },
    onOpen() {
      window.SFIDialog.show();
      $('html').css({ overflow: 'auto' });
    },
  });
}
window.openDialog = openDialog;

mountShuttersModal('shutters-div');
